export const REGION_ENUM = {
  US: 'US',
  EU: 'EU',
  UAE: 'UAE',
  IN: 'IN',
  AU: 'AU',
};

export const ALLOWED_REGIONS = Object.values(REGION_ENUM);
